<template>
  <div class="center">
    <!-- 订单详情 -->
    <div class="navBar">
      <div class="h2">订单详情</div>
      <div class="state">{{ statusText(orderDetails.status) }}</div>
    </div>
    <!-- 课程详情 -->
    <div class="subjectDetails common">
      <h4>课程 / 服务</h4>
      <div
        v-for="(item, index) in orderDetails.products"
        :key="index"
        class="details"
      >
        <div>
          <!-- 课程信息 -->
          <div
            v-if="item.product_type === 'course'"
            class="productDetails flex"
          >
            <el-image class="img" fit="cover" :src="item.product_info.cover" />
            <div class="imgDetails">
              <div>
                <span>{{ item.product_info.type_name }}</span>
                {{ item.product_info.name }}
              </div>
              <div>{{ item.product_info.description }}</div>
            </div>
          </div>
          <!-- 服务信息 -->
          <div
            v-if="item.product_type === 'service'"
            class="productDetails flex"
          >
            <el-image
              class="img"
              fit="cover"
              :src="item.product_info.image"
              style="width: 50px; height: 50px"
            />
            <div class="imgDetails">
              <div>{{ item.product_info.name }}</div>
              <div style="margin-top: 14px">
                {{ item.product_info.description }}
              </div>
            </div>
          </div>
        </div>
        <!-- 价格 -->
        <div class="left-money">
          <span>￥{{ item.product_price }}</span>
        </div>
      </div>
    </div>
    <!-- 付款信息 -->
    <!-- <div class="orderInformation common">
      <h4>支付详情</h4>
      <div class="order">
        <div class="xiangqing flex">
          <span>商品总额</span><span>￥{{ orderDetails.product_price }}</span>
        </div>
        <div v-if="orderDetails.user_coupon_money > 0" class="xiangqing flex">
          <span>优惠金额</span
          ><span>-￥{{ orderDetails.user_coupon_money }}</span>
        </div>
        <div class="xiangqing flex">
          <span>实付金额</span
          ><span class="special">￥{{ orderDetails.pay_price }}</span>
        </div>
      </div>
    </div> -->
    <!-- 订单信息 -->
    <div class="orderInformation common">
      <h4>订单详情</h4>
      <div class="order">
        <div class="xiangqing flex">
          <span>订单编号</span>
          <span class="copybox">
            <span
              v-clipboard:copy="orderDetails.order_sn"
              v-clipboard:success="doCopy"
              class="copay cursor"
              >复制</span
            >
            {{ orderDetails.order_sn }}
          </span>
        </div>
        <div class="xiangqing flex">
          <span>下单时间</span><span>{{ orderDetails.create_time_show }}</span>
        </div>
        <div class="xiangqing flex">
          <span>实付金额</span
          ><span class="special">￥{{ orderDetails.pay_price }}</span>
        </div>
        <!-- <div class="xiangqing flex">
          <span>取消时间</span><span>{{ orderDetails.invalid_time_show }}</span>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { getOrderDetails } from '@/network/request'
export default {
  name: 'OrderDetails',
  components: {},
  props: {},
  data() {
    return {
      order_sn: this.$route.query.order_sn || '',
      orderDetails: {}, // 订单详情
      // 订单完成状态
      statusShowTexts: {
        waitpay: '等待支付',
        cancel: '已取消',
        notake: '等待领取',
        refund: '已退款',
        done: '已完成',
      },
    }
  },

  computed: {
    // 获取状态文字
    statusText() {
      return (status) => {
        return this.statusShowTexts[status]
      }
    },
  },
  watch: {},
  created() {
    this.getOrderDetailss()
  },
  mounted() {},
  methods: {
    // 获取订单详情
    async getOrderDetailss() {
      const order = this.order_sn
      const res = await getOrderDetails(order)
      this.orderDetails = res.data.result
    },
    // 复制
    doCopy() {
      this.$message.success('复制成功')
    },
  },
}
</script>
<style lang="scss" scoped>
.common {
  border-radius: 4px;
  border: solid 1px #e7e7e7;
  overflow: hidden;
}
.flex {
  display: flex;
  align-items: center;
}
h4 {
  margin: 0;
  padding: 16px 24px;
  background-color: #f8f9fa;
  font-size: 16px;
}
.center {
  width: 840px;
  margin: 40px auto;
  min-height: calc(100vh - 73px - 118px - 80px);
  border-radius: 12px;
  background-color: #ffffff;
  border: solid 1px #efefef;
  padding: 30px;
  .navBar {
    width: 100%;
    display: flex;
    justify-content: space-between;
    font-size: 26px;
    margin-bottom: 31px;
    .h2 {
      color: #000000;
    }
    .state {
      color: #828282;
    }
  }
  .subjectDetails {
    border-radius: 4px;
    .details {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 24px;
      .left-money {
        display: flex;
        flex-direction: column;
        font-size: 15px;
      }
      .productDetails {
        padding: 20px 0;
        .img {
          width: 118px;
          height: 80px;
          background-color: #f8f9fa;
          border-radius: 4px;
          margin-right: 12px;
        }
        .imgDetails {
          div:nth-child(1) {
            font-size: 16px;
            color: #000000;
            span {
              margin-right: 5px;
              background-color: #ee8661;
              color: #ffffff;
              font-size: 12px;
              text-align: center;
              padding: 2px 6px;
              border-radius: 8px 0 8px 0;
            }
          }
          div:nth-child(2) {
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #999999;
            margin-top: 20px;
          }
        }
      }
    }
  }
  .orderInformation {
    margin-top: 21px;
    .order {
      padding: 0 24px;
    }
    .xiangqing {
      justify-content: space-between;
      padding: 20px 0px;
      border-bottom: 1px solid #f4f4f4;
      span {
        font-size: 16px;
        color: #333;
      }
      .special {
        color: #f04f36;
      }
      .copay {
        font-size: 13px;
        color: #00a9ff;
        border-radius: 4px;
        border: solid 1px #00a9ff;
        padding: 1px 6px;
        text-align: center;
        margin-right: 6px;
      }
    }
    .xiangqing:last-child {
      border: 0;
    }
  }
}
</style>
